import React from 'react';

interface Props { rows?: number; cols?: number; message?: string; }

export function TableSkeleton({ rows = 5, cols = 5 }: Props) {
  return (
    <div className="animate-pulse">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-3 px-4 py-3 border-b">
          {Array.from({ length: cols }).map((_, c) => (
            <div key={c} className={`h-4 bg-gray-200 rounded flex-1 ${c === 0 ? 'max-w-20' : ''}`} />
          ))}
        </div>
      ))}
    </div>
  );
}

export function CardSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="grid grid-cols-4 gap-4 animate-pulse">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-xl border p-4 space-y-3">
          <div className="h-3 bg-gray-200 rounded w-3/4" />
          <div className="h-8 bg-gray-200 rounded w-1/2" />
          <div className="h-3 bg-gray-200 rounded w-2/3" />
        </div>
      ))}
    </div>
  );
}

export function Spinner({ size = 'md', message }: { size?: 'sm'|'md'|'lg'; message?: string }) {
  const s = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12' }[size];
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12">
      <div className={`${s} border-2 border-gray-200 border-t-[#02357A] rounded-full animate-spin`} />
      {message && <p className="text-sm text-gray-500">{message}</p>}
    </div>
  );
}
